export const formContent = {
    heading: 'Verification Code',
    description: 'Please type the verification code send to',
    code: {
        id: 'code',
        type: 'number',
        label: '',
        validation: {
            required: "Please enter verification code"
        }
    },
    verifyButton: {
        id: 'verifyButton',
        label: 'Verify',
        type: 'submit'
    },
    resendLink: {
        id: 'resendLink',
        label: 'Resend Code',
        href: '#'
    },
}
